export default __webpack_public_path__ + "locales/lo-LA/VersionHistory.json?hash=6ea60e8ce9c267c9d27e58417d5ce375";